<!--
  Created 10.10.2023
  Interactive Map component for the proposal show page.
-->
<template>
  <div class="container mx-auto px-6">
    <div class="min-h-[24rem] bg-gray-200">
      Interactive Map
    </div>
  </div>
</template>
<script setup>

</script>
